export default class VerticalScroll {
  constructor(element) {
    this.element = element;
    this.trigger = this.element.querySelector('.vertical-scroll-trigger');
    this.sticky = this.element.querySelector('.vertical-scroll-sticky');
    this.textItems = this.element.querySelectorAll(
      '.vertical-scroll-text-item'
    );
    this.imageItems = this.element.querySelectorAll('.vertical-scroll-img');
    this.container = this.element.querySelector('.container-radius');

    this.currentIndex = 0;
    this.itemCount = this.textItems.length;

    this.radiusClasses = [
      'why-img-top-left',
      'why-img-top-right',
      'why-img-bottom-right',
      'why-img-bottom-left',
    ];

    this.init();
  }

  init() {
    if (!this.trigger || !this.sticky || this.itemCount === 0) return;

    // Initialiser la première image et le premier border-radius
    if (this.imageItems.length > 0) {
      this.imageItems[0].classList.add('active');
    }
    if (this.container && this.radiusClasses[0]) {
      this.container.classList.add(this.radiusClasses[0]);
    }

    // Écouter le scroll avec throttle pour performance
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });

    this.handleScroll();
  }

  handleScroll() {
    const sectionRect = this.element.getBoundingClientRect();
    const sectionTop = sectionRect.top;
    const sectionHeight = sectionRect.height;
    const windowHeight = window.innerHeight;

    // Avant que la section n'entre dans la vue
    if (sectionTop > 0) {
      this.setActiveIndex(0);
      return;
    }

    // Après que la section soit complètement passée
    if (sectionTop < -sectionHeight + windowHeight) {
      this.setActiveIndex(this.itemCount - 1);
      return;
    }

    // Calculer la progression pendant que la section est sticky
    const progress = Math.abs(sectionTop) / (sectionHeight - windowHeight);
    const newIndex = Math.floor(progress * this.itemCount);
    const validIndex = Math.max(0, Math.min(newIndex, this.itemCount - 1));

    this.setActiveIndex(validIndex);
  }

  setActiveIndex(index) {
    if (index === this.currentIndex) return;

    const oldIndex = this.currentIndex;
    const scrollingDown = index > oldIndex;
    this.currentIndex = index;

    this.textItems.forEach((item, i) => {
      item.classList.remove('active');

      if (i === index) {
        // Le nouvel item actif
        item.classList.add('active');
      }
    });

    // Mettre à jour les classes active sur les images
    this.imageItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    // Mettre à jour le border-radius du container
    if (this.container) {
      this.radiusClasses.forEach((className) => {
        this.container.classList.remove(className);
      });

      if (this.radiusClasses[index]) {
        this.container.classList.add(this.radiusClasses[index]);
      }
    }
  }
}
